import React from 'react';

import { BodyText, BodyTextProps, TableData, TableDataProps } from '@make-software/cspr-design';
import styled from 'styled-components';

export const StyledContentRow = styled.div(({ theme }) =>
  theme.withMedia({
    position: 'relative',
    top: '11px'
  })
);

/* eslint-disable-next-line */
export interface DetailsValueTableDataProps extends TableDataProps {
  monotype?: boolean;
  loading?: boolean;
  noWrap?: boolean;
  bodyTextProps?: BodyTextProps;
}

export function DetailsValueTableData({
  children,
  monotype,
  loading,
  noWrap,
  bodyTextProps,
  ...props
}: DetailsValueTableDataProps) {
  return (
    <TableData {...props}>
      <BodyText
        monotype={monotype}
        loading={loading}
        noWrap={noWrap}
        {...bodyTextProps}
        size={bodyTextProps?.size || 3}
      >
        <StyledContentRow>{children}</StyledContentRow>
      </BodyText>
    </TableData>
  );
}

export default DetailsValueTableData;
